"use strict";
var TravelerDetailConfig = (function () {
    function TravelerDetailConfig() {
    }
    return TravelerDetailConfig;
}());
exports.TravelerDetailConfig = TravelerDetailConfig;
//# sourceMappingURL=D:/a/1/s/eligibility/src/rules/models/traveler-detail-config.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/rules/models/traveler-detail-config.model.js